import convertOrderLineToGoogleTagManagerItem from "./convertOrderLineToGoogleTagManagerItem";
export class GoogleTagManagerProvider {
    constructor() {
        this.currency = "NOK";
    }
    // This is used when one operation can both add and remove items
    // from the cart. The only example I can think of is the
    // desktop "digital mini cart"-ordering
    onCartChange(cartUpdate) {
        this.clearDatalayerEcommerce();
        console.log("Cart update!", cartUpdate);
        if (cartUpdate.newOrderLines && cartUpdate.newOrderLines.length > 0) {
            this.trackItemsEvent("add_to_cart", cartUpdate.newOrderLines);
        }
        if (cartUpdate.removedOrderLines &&
            cartUpdate.removedOrderLines.length > 0) {
            this.trackItemsEvent("remove_from_cart", cartUpdate.removedOrderLines);
        }
    }
    onLogin(user) {
        const encoder = new TextEncoder();
        const data = encoder.encode(user.emailAddress);
        // Create a sha-256-hash
        crypto.subtle.digest("SHA-256", data).then((hashBuffer) => {
            // Convert the ArrayBuffer to hex string
            const emailHashArray = Array.from(new Uint8Array(hashBuffer));
            const emailHex = emailHashArray
                .map((b) => b.toString(16).padStart(2, "0"))
                .join("");
            const event = {
                event: "login",
                login_status: "logged in",
                email: emailHex,
                user_id: user.uuid,
            };
            window.dataLayer.push(event);
        });
    }
    onRegisterUser(user) {
        this.onLogin(user);
    }
    onPageUser(user) {
        const encoder = new TextEncoder();
        const data = encoder.encode(user.emailAddress);
        // Create a sha-256-hash
        crypto.subtle.digest("SHA-256", data).then((hashBuffer) => {
            // Convert the ArrayBuffer to hex string
            const emailHashArray = Array.from(new Uint8Array(hashBuffer));
            const emailHex = emailHashArray
                .map((b) => b.toString(16).padStart(2, "0"))
                .join("");
            const event = {
                event: "login",
                login_status: user.isAnonymousUser ? "logged out" : "logged in",
            };
            if (!user.isAnonymousUser) {
                event.email = emailHex;
                event.user_id = user.uuid;
            }
            window.dataLayer.push(event);
        });
    }
    onAddToCart(items) {
        this.clearDatalayerEcommerce();
        this.trackItemsEvent("add_to_cart", items);
    }
    onRemoveFromCart(items) {
        this.clearDatalayerEcommerce();
        this.trackItemsEvent("remove_from_cart", items);
    }
    onViewCart(items) {
        this.clearDatalayerEcommerce();
        this.trackItemsEvent("view_cart", items);
    }
    onBeginCheckout(items) {
        this.clearDatalayerEcommerce();
        this.trackItemsEvent("begin_checkout", items);
    }
    onPurchaseSuccessful(order) {
        var _a, _b, _c, _d;
        const totalSum = order.summary.totalPrice;
        const tax = (_b = (_a = order.orderLines.find((ol) => ol.type === 4)) === null || _a === void 0 ? void 0 : _a.linePrice) !== null && _b !== void 0 ? _b : 0;
        const shippingFee = (_d = (_c = order.orderLines.find((ol) => ol.type === 3)) === null || _c === void 0 ? void 0 : _c.linePrice) !== null && _d !== void 0 ? _d : 0;
        const items = order.orderLines.filter((item) => {
            return item.type === 0 && "uuid" in item;
        });
        const eventData = {
            currency: this.currency,
            transaction_id: order.uuid,
            value: totalSum.toFixed(2),
            tax: tax.toFixed(2),
            shipping: shippingFee.toFixed(2),
            coupon: order.rebateCode,
            items: items
                .map((item) => {
                return convertOrderLineToGoogleTagManagerItem(item);
            })
                .filter((item) => item !== null),
        };
        window.gtag("event", "purchase", eventData);
    }
    trackItemsEvent(eventName, items) {
        const eventData = {
            currency: this.currency,
            value: this.calculateTotalValue(items).toFixed(2),
            items: items
                .map((item) => {
                return convertOrderLineToGoogleTagManagerItem(item);
            })
                .filter((item) => item !== null),
        };
        console.log(`[GTM-event] ${eventName}`, items, eventData);
        window.gtag("event", eventName, eventData);
    }
    setAllowTracking(value) {
        window.gtag("consent", "update", {
            analytics_storage: value ? "granted" : "denied",
        });
    }
    setCurrency(code) {
        this.currency = code;
    }
    calculateTotalValue(items) {
        return items.reduce((totalSum, orderLine) => {
            totalSum += orderLine.actualLinePrice;
            return totalSum;
        }, 0);
    }
    clearDatalayerEcommerce() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            ecommerce: null,
        });
        console.log("[gtag] Clear dataLayer");
    }
}
